import { render, staticRenderFns } from "./FooterAdmin.vue?vue&type=template&id=5bc8c9fe&scoped=true&"
import script from "./FooterAdmin.vue?vue&type=script&lang=js&"
export * from "./FooterAdmin.vue?vue&type=script&lang=js&"
import style0 from "./FooterAdmin.vue?vue&type=style&index=0&id=5bc8c9fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc8c9fe",
  null
  
)

export default component.exports